import { render, staticRenderFns } from "./editOrgaApartment.vue?vue&type=template&id=71241810&scoped=true"
import script from "./editOrgaApartment.vue?vue&type=script&lang=js"
export * from "./editOrgaApartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71241810",
  null
  
)

export default component.exports